export default {
  userList: state => state.userList,
}
